import { z } from "zod";
import { ClientSchema } from "./client";
import { UserSchema } from "./user";
import { BuildingSchema } from "./building";
import { JobSchema } from "./job";

const dateTransform = z.preprocess(
  (val) => (val ? new Date(val as string) : null),
  z.date().nullable()
);

export const EventSchema = z.object({
  eid: z.number(),
  euid: z.number().nullable().optional(),
  ejid: z.number().nullable().optional(),
  ecid: z.number().nullable().optional(),
  elid: z.number().nullable().optional(),
  elocid: z.number().nullable().optional(),
  einid: z.number().nullable().optional(),
  etype: z.string().nullable().optional(),
  estartdts: dateTransform,
  eenddts: dateTransform,
  eallday: z.string().max(3).nullable().optional(),
  etitle: z.string().max(84).nullable().optional(),
  edesc: z.string().nullable().optional(),
  estatus: z.string().max(8).nullable().optional(),
  eauid: z.number().nullable().optional(),
  eauids: z.string().nullable().optional(),
  eadts: dateTransform,
  eduration: z.number().nullable().optional(),
  edurationtyp: z.string().max(6).nullable().optional(),
  notify_emails: z.string().nullable().optional(),
  notify_names: z.string().nullable().optional(),
  eworktype: z.string().max(20).nullable().optional(),
  eservices: z.string().max(255).nullable().optional(),
  client: z.object(ClientSchema.shape).nullable().optional(),
  staff: z.object(UserSchema.shape).nullable().optional(),
  creator: z.object(UserSchema.shape).nullable().optional(),
  eventBuilding: z.object(BuildingSchema.shape).nullable().optional(),
  building: z.object(BuildingSchema.shape).nullable().optional(),
  job: z.object(JobSchema.shape).nullable().optional()
});

// Create schemas (omit auto-generated fields)
export const CreateEventSchema = EventSchema.omit({ eid: true });

// Update schemas (make all fields optional except ID)
export const UpdateEventSchema = EventSchema.partial().required({ eid: true });

// Type definitions
export type Event = z.infer<typeof EventSchema>;
export type CreateEvent = z.infer<typeof CreateEventSchema>;
export type UpdateEvent = z.infer<typeof UpdateEventSchema>; 